/* global axios */
import ApiClient from './ApiClient';

class TicketCompaniesApi extends ApiClient {
  constructor() {
    super('ticket_companies', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TicketCompaniesApi();
